import axios from "axios";

export const getCustomersAPI = ({page, limit}) => axios.get(`{server}/admin/users/customers?page=${page}&limit=${limit}`).then(res => res.data.success)